
  $(document).ready(function(){
    $('.read_more_less').on('click', function(e){
      e.preventDefault();
      if($('.product-description-full:visible')[0]){
        $('.product-description-full').fadeOut(function(){ 
          $('.product-description-short').fadeIn();
        });
      }else{
        $('.product-description-short').fadeOut(function(){ 
          $('.product-description-full').fadeIn();
        });
      }
    });
  });



document.addEventListener('DOMContentLoaded', function () {
  // Get all color swatch elements
  var colorSwatches = document.querySelectorAll('.swatch-element');

  // Get the flickity-slider element
  var flickitySlider = document.querySelector('.flickity-slider');

  // Add click event listener to each color swatch
  colorSwatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      // Remove active class from all color swatches
      colorSwatches.forEach(function (otherSwatch) {
        otherSwatch.classList.remove('active');
      });

      // Add active class to the clicked color swatch
      swatch.classList.add('active');

      // Check data-value of the active swatch
      var activeDataValue = swatch.getAttribute('data-value');

      // Iterate through gallery cells under flickity-slider
      var galleryCells = document.querySelectorAll('.gallery-cell');
      // galleryCells.forEach(function (cell) {
      //   // Check data-title of the gallery cell
      //   var cellDataTitle = cell.getAttribute('data-title');

      //   // Toggle display property based on matching conditions
      //   if (activeDataValue === cellDataTitle) {
      //      cell.id = 'block';
      //   } else {
      //      cell.id = 'none';
      //   }
      // });
    });
  });

  // Set the active class for the first color swatch initially
  colorSwatches[0].classList.add('active');
});




// // Select all .menu-inner-image elements
// const menuInnerImagess = document.querySelectorAll('.menu-inner-image img');

// // Select the new_stock element where you want to add the image src links
// const newStock = document.querySelector('.new_stock');

// // Loop through each image and add the src to new_stock
// menuInnerImagess.forEach((img) => {
//   if (img.src) {
//     // Create a new element to hold the src (could be an <img>, <a>, or <span> depending on your need)
//     const newImageElement = document.createElement('img');
//     newImageElement.src = img.src;
//     newImageElement.alt = img.alt;
//     newImageElement.className = 'new-stock-image'; // Optional class if styling is needed
    
//     // Append the new image to the new_stock container
//     newStock.appendChild(newImageElement);
//   }
// });


